export default {
  campaignIndex: 'campaigns-status',
  campaignError: 'campaigns-errors',
  campaignShow: 'campaigns-id-show-tab',
  dashboard: 'index',
  login: 'login',
  routers: 'routers',
  sources: 'sources',
  users: 'users',
  usersId: 'users-id',
  usersAdd: 'users-add',
  changePassword: 'change-password',
  variableSchemas: 'variable-schemas',
  variableSchemasAdd: 'variable-schemas-add',
  variableSchemasId: 'variable-schemas-id',
}
